import React, { useState } from 'react';
import { Check, ArrowRight } from 'lucide-react';
import { PACKAGES } from '../mock/mock';

export default function Packages() {
  const [active, setActive] = useState(PACKAGES[0].id);
  const pkg = PACKAGES.find((p) => p.id === active);

  return (
    <section id="keszhazak" className="relative py-24 md:py-32 bg-white overflow-hidden">
      {/* Top fade from cream */}
      <div aria-hidden className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-[#f5f0e8] to-transparent pointer-events-none" />
      {/* Decorative accents */}
      <div aria-hidden className="absolute top-1/3 -left-20 w-96 h-96 rounded-full bg-[#2BA8C0]/[0.04] blur-3xl pointer-events-none" />
      <div aria-hidden className="absolute bottom-20 right-1/4 w-80 h-80 rounded-full bg-[#0d2336]/[0.03] blur-3xl pointer-events-none" />
      {/* faint house illustration */}
      <div aria-hidden className="absolute right-0 top-1/4 w-[420px] h-[320px] opacity-[0.08] pointer-events-none">
        <svg viewBox="0 0 400 300" className="w-full h-full text-[#0d2336]">
          <path d="M50 250 L50 130 L200 30 L350 130 L350 250 Z" fill="none" stroke="currentColor" strokeWidth="2" />
          <rect x="170" y="160" width="60" height="90" fill="none" stroke="currentColor" strokeWidth="2" />
          <rect x="90" y="170" width="50" height="50" fill="none" stroke="currentColor" strokeWidth="2" />
          <rect x="260" y="170" width="50" height="50" fill="none" stroke="currentColor" strokeWidth="2" />
        </svg>
      </div>

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mb-12">
          <div className="flex items-center gap-3 mb-6">
            <span className="section-num text-[#2BA8C0] text-2xl">04</span>
            <span className="text-[12px] uppercase tracking-[0.3em] text-[#7a7a7a] font-medium">Szolgáltatások</span>
          </div>
          <h2 className="font-serif-display text-4xl md:text-6xl text-[#1a1a1a] leading-[1.05] mb-6">
            Könnyűszerkezetes készházak<br /><span className="italic text-[#2BA8C0]">három egyszerű csomagban.</span>
          </h2>
          <p className="text-[#5a5a5a] text-[16px] leading-relaxed max-w-2xl">
            Egyetlen bevált technológia – a könnyűszerkezetes vázrendszer. Három átgondolt kialakítás, mindegyik kulcsrakészen átadva.
          </p>
        </div>

        {/* Tabs */}
        <div className="flex flex-wrap gap-3 mb-10">
          {PACKAGES.map((p) => {
            const isActive = active === p.id;
            return (
              <button
                key={p.id}
                onClick={() => setActive(p.id)}
                className={`group flex items-center gap-3 px-5 py-3.5 rounded-full border transition-all ${isActive ? 'bg-[#2BA8C0] border-[#2BA8C0] text-white shadow-md' : 'bg-transparent border-transparent text-[#3a3a3a] hover:bg-[#f5f0e8]'}`}
              >
                <span className={`section-num text-[15px] ${isActive ? 'text-white/90' : 'text-[#9a9a9a]'}`}>{p.badge}</span>
                <span className="text-[14px] font-medium">{p.label}</span>
                {isActive && p.popular && (
                  <span className="text-[10px] uppercase tracking-[0.15em] px-2.5 py-0.5 rounded-full bg-white/20 text-white font-semibold">Népszerű</span>
                )}
              </button>
            );
          })}
        </div>

        {/* Active package */}
        <div className="grid lg:grid-cols-12 gap-8 items-stretch">
          <div className="lg:col-span-7">
            <div className="relative rounded-3xl overflow-hidden aspect-[4/3] bg-[#0d2336] shadow-xl">
              <img src={pkg.image} alt={pkg.title} className="w-full h-full object-cover" />
              <div className="absolute top-5 left-5 bg-white px-3.5 py-1.5 rounded-full flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-[#2BA8C0]" />
                <span className="text-[11px] uppercase tracking-wider text-[#1a1a1a] font-semibold">Velencei-tó</span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-7 bg-gradient-to-t from-black/85 via-black/30 to-transparent">
                <h3 className="font-serif-display text-3xl md:text-4xl text-white mb-2">{pkg.title}</h3>
                <p className="text-white/85 text-[14px] leading-relaxed max-w-xl">{pkg.desc}</p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-5 flex flex-col">
            <div className="grid grid-cols-3 gap-3 mb-6">
              {pkg.specs.map((s) => (
                <div key={s.label} className="bg-[#f5f0e8] rounded-2xl p-4 text-center">
                  <div className="font-serif-display text-xl md:text-2xl text-[#1a1a1a]">{s.value}</div>
                  <div className="text-[10px] uppercase tracking-wider text-[#7a7a7a] mt-1">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="mb-6 flex-1">
              <p className="text-[12px] uppercase tracking-[0.2em] text-[#9a9a9a] font-semibold mb-4">Mit tartalmaz</p>
              <ul className="space-y-3">
                {pkg.items.map((it, i) => (
                  <li key={i} className="flex items-start gap-3 text-[#3a3a3a] text-[14px]">
                    <span className="w-5 h-5 rounded-full bg-[#2BA8C0]/10 flex items-center justify-center shrink-0 mt-0.5">
                      <Check className="w-3 h-3 text-[#2BA8C0]" />
                    </span>
                    <span>{it}</span>
                  </li>
                ))}
              </ul>
            </div>

            <a
              href="#survey"
              className="inline-flex items-center justify-center gap-2 px-6 py-4 rounded-full bg-[#2BA8C0] text-white text-[14px] font-medium hover:bg-[#239ab1] transition-colors shadow-md"
            >
              Árajánlatot kérek erre
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
